import React, { ReactElement } from 'react';
import { ServerFailMessage } from './ServerFailMessage';
import { ServerFailPage } from './ServerFailPage';
import { ComponentType, Props } from './';

const ServerFail: ComponentType = ({
  isErrorTimeout,
  onReloadClick,
  className,
  isMessage = true,
}: Props): ReactElement => {
  if (isMessage) {
    return (
      <ServerFailMessage
        isErrorTimeout={isErrorTimeout}
        onReload={onReloadClick}
        className={className}
      />
    );
  }

  return (
    <ServerFailPage
      isErrorTimeout={isErrorTimeout}
      onReload={onReloadClick}
      className={className}
    />
  );
};

export { ServerFail };
